<template>
  <SidePopup
    :title="title"
    v-on:close="onClose"
    @submit="onSubmit"
    :loading="isLoading"
    routeback="/fornecedor/cadastro/imagens-produto"
  >
    <v-row no-gutters>
      <FormSwitch v-model="form.cargaTotal" label="Carga total de imagens" />
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="ml-3 mt-n3" size="20">
            far fa-question-circle
          </v-icon>
        </template>
        Se habilitado, todas as imagens serão processadas. A seleção individual
        de produtos será ignorada.
      </v-tooltip>
    </v-row>
    <div v-if="form.cargaTotal" class="mt-6 mb-10">
      Será processada a carga total de imagens. Este processo pode demorar
      alguns minutos.
    </div>
    <div v-else class="mt-6 mb-10">
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        :filters="filters"
        sortBy="nome"
        :sortDesc="false"
        showSelect
        search
        noHideFilters
        :limitPage="[10, 25, 50, 100, 200, 300, 400, 500]"
        v-model="produtosSelecionados"
        :auto-search="false"
      >
        <template v-slot:tem_imagem="{ col }">
          <Chip v-if="col" color="green" text="Sim" :small="true" />
          <Chip v-else color="cyan" text="Não" :small="true" />
        </template>

        <template v-slot:granularidade="{ col }">
          <Chip
            v-if="col && (col > 1 || col < 1)"
            color="green"
            text="Sim"
            :small="true"
          />
          <Chip v-else color="cyan" text="Não" :small="true" />
        </template>
      </DataTable>
    </div>

    <template v-slot:buttons>
      <FormButton text="Enviar" submit type="submissao" />
    </template>
  </SidePopup>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import DataTable from "@/components/DataTable";
import FormSwitch from "@/components/form/FormSwitch";
import FormButton from "@/components/form/FormButton";
import Chip from "@/components/Chip";
import { mapGetters } from "vuex";
import { CARGA_IMAGEM_PRODUTO } from "@/store/actions/imagemProduto";

export default {
  name: "ImportarImagensProdutos",
  components: {
    SidePopup,
    DataTable,
    FormSwitch,
    FormButton,
    Chip
  },
  data: () => ({
    isLoading: false,
    form: {
      cargaTotal: false
    },
    produtosSelecionados: [],
    headers: [
      { text: "Nome", value: "nome" },
      { text: "Código de barras", value: "codigobarras", align: "center" },
      { text: "Código interno", value: "id_produto_erp", align: "center" },
      { text: "Agrupador Emb.", value: "agrupador_embalagem", align: "center" },
      { text: "Unidade de Venda", value: "label_unidade", align: "center" },
      { text: "Tem imagem", value: "tem_imagem", align: "center" }
    ]
  }),
  computed: {
    ...mapGetters(["getFornecedorId"]),
    title() {
      return "Carregamento de imagens de produtos";
    },
    filters() {
      return [
        { label: "Código de barras", query: "codigobarras" },
        { label: "Código interno", query: "codigointerno" },
        { label: "Agrupador de embalagem", query: "agrupador" },
        {
          label: "Vínculo de imagem",
          query: "temimagem",
          options: [
            { text: "Todos", value: "" },
            { text: "Com imagem", value: "true" },
            { text: "Sem imagem", value: "false" }
          ],
          cols: 4
        }
      ];
    },
    endpoint() {
      return `/api/v1/produtos/datableformat?idfornecedor=${this.getFornecedorId}&fp=`;
    }
  },
  methods: {
    onClose(routeBack = false) {
      this.isLoading = false;
      this.$emit("close");
      if (routeBack) {
        this.$router.replace("/fornecedor/cadastro/imagens-produto");
      }
    },
    onSubmit() {
      if (!this.form.cargaTotal && this.produtosSelecionados.length === 0) {
        this.$vueOnToast.pop("error", "Selecione pelo menos um produto!");
        return;
      }

      this.isLoading = true;
      const payload = {
        cargaTotal: this.form.cargaTotal,
        ids: this.form.cargaTotal
          ? []
          : this.produtosSelecionados.map(p => p.idcadastroextraproduto)
      };

      this.$store
        .dispatch(CARGA_IMAGEM_PRODUTO, payload)
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            "O comando remoto de processamento de imagens foi enviado para a integração."
          );
          this.onClose(true);
        })
        .catch(err => {
          const erro =
            err.response?.data?.Mensagem ||
            err.response?.data ||
            "Não foi possível enviar o comando de processamento de imagens";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss"></style>
